import React from 'react';
import { Box } from '@mui/material';

/** Compact "New" chip — matches Home +N purple language (designer, design-preview 469041a3). */
const newCompanyChipSx = (theme) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 18,
  minHeight: 18,
  px: 0.625,
  py: 0,
  borderRadius: '6px',
  fontSize: '10.5px',
  fontWeight: 700,
  lineHeight: 1,
  letterSpacing: 0,
  textAlign: 'center',
  flexShrink: 0,
  boxSizing: 'border-box',
  bgcolor: theme.palette.mode === 'dark' ? 'rgba(168, 148, 255, 0.18)' : 'rgba(74, 44, 245, 0.08)',
  color: theme.palette.primary.main,
  border: `1px solid ${
    theme.palette.mode === 'dark' ? 'rgba(168, 148, 255, 0.32)' : 'rgba(74, 44, 245, 0.18)'
  }`,
});

export default function EnrichmentGridNewCompanyChip() {
  return (
    <Box component="span" sx={newCompanyChipSx} data-testid="enrichment-new-company-chip">
      New
    </Box>
  );
}

/** Set of new-company row ids (stagedId) from an array or Set, or null when none. */
export function toNewCompanyIdSet(newCompanyIds) {
  const list = newCompanyIds instanceof Set ? Array.from(newCompanyIds) : newCompanyIds;
  if (!Array.isArray(list) || list.length === 0) return null;
  return new Set(list.map(String));
}
